var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 37,
    height: 37,
    transform: "translate(0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-2",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(0.175 7.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M34.706,21.689h-.5a2.956,2.956,0,0,0-5.772,0h-.508V16.134h6.782v5.555ZM31.307,24a1.674,1.674,0,1,1,1.68-1.671A1.678,1.678,0,0,1,31.307,24ZM27.92,12.022h4.265a.6.6,0,0,1,.507.288l1.523,2.54H27.923l0-2.828Zm-1.28-.64V21.689h-7a2.952,2.952,0,0,0-5.768,0H12.525V10.107a1.825,1.825,0,0,1,1.824-1.823H24.819a1.824,1.824,0,0,1,1.824,1.823l0,1.275ZM18.429,22.335a1.637,1.637,0,1,1,0-.017Zm17.536-6.92a.642.642,0,0,0-.058-.214c-.007-.012,0-.028-.011-.04L33.79,11.653a1.878,1.878,0,0,0-1.6-.911H27.92V10.1a3.107,3.107,0,0,0-3.1-3.1H14.349a3.107,3.107,0,0,0-3.1,3.108V22.33a.64.64,0,0,0,.639.641H13.87a2.952,2.952,0,0,0,5.763,0h8.8a2.951,2.951,0,0,0,5.758,0h1.158a.641.641,0,0,0,.639-.641V15.5a.613.613,0,0,0-.02-.09Zm-35.4-.543h9a.562.562,0,1,1,0,1.125h-9a.562.562,0,1,1,0-1.125Zm5.623-4.5H9.559a.562.562,0,1,1,0,1.125H6.185a.562.562,0,1,1,0-1.125Zm-2.249,9H9.559a.562.562,0,1,1,0,1.125H3.936a.562.562,0,1,1,0-1.125Z",
    transform: "translate(0 -7)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.96ec36331eaf17afb7cfb69b4b898e69.svg";
export { ForwardRef as ReactComponent };